import Container, { Service } from "typedi";
import IHttpClientGetParameters from "../contracts/http-client/http-client-get-parameters.interface";
import HttpClient from "./http-client.service";

@Service()
export default class RegistrationLinkService {
  public async validateRegistrationLink (event_identifier: string, registration_link: string) {
    const httpParams: IHttpClientGetParameters = {
      url: `/event/${event_identifier}/registration-link/${encodeURIComponent(registration_link)}/validate`,
      requireToken: false
    }
    const response: any = await Container.get(HttpClient).get(httpParams, event_identifier)
    return response
  }
}
